<template>
	<div class="contact-container-dropdown">
		<BreadCrumb />
		<div class="container">
			<div class="title font-34 uppercase bold">
				{{ _.get($store.state.main, 'selected_menu.title') }}
			</div>
			<div class="teaser bold">
				{{
					_.get(contentData, 'conf.header.teaser') ||
						_.get($store.state.main, 'selected_menu.teaser')
				}}
			</div>
			<div class="dropdowns">
				<div class="dropdown-item" :class="{ open: selectedId == 'map' }">
					<div @click="toggle('map')" class="top pointer flex al-center between">
						<div class="title bold uppercase">{{ $fn.tr('ქალაქის რუკა') }}</div>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="10"
							height="7.857"
							viewBox="0 0 10 7.857"
						>
							<path
								id="Icon_material-play-arrow"
								data-name="Icon material-play-arrow"
								d="M12,7.5v10l7.857-5Z"
								transform="translate(17.5 -12) rotate(90)"
								fill="#4d4d4f"
							/>
						</svg>
					</div>
					<slide-up-down :active="selectedId == 'map'" :duration="600" class="content">
						<div class="content-container">
							<GmapMap
								class="map"
								:center="center"
								:zoom="zoomData"
								ref="mapRef"
								:options="{
									styles: mapStyle,
									zoomControl: true,
									gestureHandling: 'cooperative',
								}"
							>
								<GmapMarker
									v-for="(item, index) in _.get(contentData, 'data.list')"
									:key="index"
									:clickable="true"
									:icon="_.get(item, 'Icon[0].devices.desktop')"
									@click="setMarker(item)"
									:position="{
										lat: parseFloat(_.get(item, 'map[0].lat')),
										lng: parseFloat(_.get(item, 'map[0].long')),
									}"
								>
								</GmapMarker>
							</GmapMap>
						</div>
					</slide-up-down>
				</div>
				<div class="dropdown-item" :class="{ open: selectedId == 'mall-map' }">
					<div @click="toggle('mall-map')" class="top pointer flex al-center between">
						<div class="title bold uppercase">{{ $fn.tr('მოლის რუკა') }}</div>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="10"
							height="7.857"
							viewBox="0 0 10 7.857"
						>
							<path
								id="Icon_material-play-arrow"
								data-name="Icon material-play-arrow"
								d="M12,7.5v10l7.857-5Z"
								transform="translate(17.5 -12) rotate(90)"
								fill="#4d4d4f"
							/>
						</svg>
					</div>
					<slide-up-down :active="selectedId == 'mall-map'" :duration="600" class="content">
						<div class="content-container">
							<MapBlock :drop_down="true" />
						</div>
					</slide-up-down>
				</div>
				<div class="dropdown-item" :class="{ open: selectedId == 'contact' }">
					<div @click="toggle('contact')" class="top pointer flex al-center between">
						<div class="title bold uppercase">
							{{ $fn.tr('სამუშაო საათები და კონტაქტი') }}
						</div>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="10"
							height="7.857"
							viewBox="0 0 10 7.857"
						>
							<path
								id="Icon_material-play-arrow"
								data-name="Icon material-play-arrow"
								d="M12,7.5v10l7.857-5Z"
								transform="translate(17.5 -12) rotate(90)"
								fill="#4d4d4f"
							/>
						</svg>
					</div>
					<slide-up-down :active="selectedId == 'contact'" :duration="600" class="content">
						<div class="content-container contact">
							<div class="contact">
								<div class="row flex column" :key="indx" v-for="(item, indx) in contactInfo.data">
									<div class="title bold">
										{{ item.title }}
									</div>
									<a :href="'tel:' + item.content" v-if="item.title == 'phone'" class="content">
										{{ item.content }}
									</a>
									<div v-else class="content">
										{{ item.content }}
									</div>
								</div>
								<div class="row flex column">
									<div class="title bold">{{ socialChannels.title }}</div>
									<div class="flex icons">
										<a
											:href="_.get(channel, 'url')"
											target="_blank"
											class="item flex al-center pointer"
											v-for="(channel, index) in socialChannels.list"
											:key="index"
											v-html="_.get(channel, 'svg')"
										></a>
									</div>
								</div>
								<div class="row flex column">
									<img class="qr-img" :src="_.get(contactInfo, 'qrCode.content')" alt="" />
								</div>
							</div>
						</div>
					</slide-up-down>
				</div>
				<div class="dropdown-item" :class="{ open: selectedId == 'send' }">
					<div @click="toggle('send')" class="top pointer flex al-center between">
						<div class="title bold uppercase">{{ $fn.tr('მოგვწერეთ') }}</div>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="10"
							height="7.857"
							viewBox="0 0 10 7.857"
						>
							<path
								id="Icon_material-play-arrow"
								data-name="Icon material-play-arrow"
								d="M12,7.5v10l7.857-5Z"
								transform="translate(17.5 -12) rotate(90)"
								fill="#4d4d4f"
							/>
						</svg>
					</div>
					<slide-up-down :active="selectedId == 'send'" :duration="600" class="content">
						<div class="content-container">
							<div class="send-message">
								<div class="title uppercase font-34 light">
									{{ $fn.tr('გამოგვიგზავნეთ შეტყობინება') }}
								</div>
								<div class="teaser font-14 bold">
									{{
										$fn.tr(
											'გამოგზავნილი შეტყობინება განიხილება და უახლოეს პერიოდში დაგიბრუნდებათ პასუხი.'
										)
									}}
								</div>
								<div class="send-message-content">
									<el-form
										@submit.prevent.native="
											'';


										"
										:model="contactData"
										:rules="rules"
										ref="contact"
										class="form-container"
									>
										<div class="row">
											<el-form-item prop="name">
												<el-input
													class="default-input-style"
													:placeholder="$fn.tr('სახელი')"
													v-model="contactData.name"
												></el-input>
											</el-form-item>
											<el-form-item prop="email">
												<el-input
													class="default-input-style"
													:placeholder="$fn.tr('ელ. ფოსტა')"
													v-model="contactData.email"
												></el-input>
											</el-form-item>
											<el-form-item prop="title">
												<el-input
													class="default-input-style"
													:placeholder="$fn.tr('სათაური')"
													v-model="contactData.title"
												></el-input>
											</el-form-item>
										</div>
										<div class="row">
											<el-form-item prop="message" class="textbox">
												<el-input
													class="default-input-style"
													:placeholder="$fn.tr('შეტყობინება')"
													type="textarea"
													v-model="contactData.message"
												></el-input>
											</el-form-item>
											<div @click="sendData" class="send-button pointer bold uppercase">
												{{ $fn.tr('გაგზავნა') }}
											</div>

											<transition name="toggleContent" mode="out-in">
												<div class="success-message" v-if="success">
													{{ $fn.tr('sent successfully') }}
												</div>
											</transition>
										</div>
									</el-form>
								</div>
							</div>
						</div>
					</slide-up-down>
				</div>
				<div class="dropdown-item" :class="{ open: selectedId == 'transport' }">
					<div @click="toggle('transport')" class="top pointer flex al-center between">
						<div class="title bold uppercase">
							{{ $fn.tr('როგორ მოხვიდე') }}
						</div>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="10"
							height="7.857"
							viewBox="0 0 10 7.857"
						>
							<path
								id="Icon_material-play-arrow"
								data-name="Icon material-play-arrow"
								d="M12,7.5v10l7.857-5Z"
								transform="translate(17.5 -12) rotate(90)"
								fill="#4d4d4f"
							/>
						</svg>
					</div>
					<slide-up-down :active="selectedId == 'transport'" :duration="600" class="content">
						<div class="content-container transport">
							<div class="transports ">
								<div
									class="item flex al-center"
									:key="index"
									v-for="(item, index) in transport.list"
								>
									<div class="img" v-html="_.get(item, 'svg')" v-if="_.get(item, 'svg')"></div>
									<div class="flex column" v-if="_.get(item, 'title')">
										<div class="title bold uppercase">
											{{ _.get(item, 'title') }}
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="15.958"
												height="14.91"
												viewBox="0 0 15.958 14.91"
											>
												<path
													id="Path_3650"
													data-name="Path 3650"
													d="M190,645.931h-2.705l-.253,2.142h2.27v3.571h-2.683l-.3,2.6h-3.783l.3-2.6h-2.453l-.3,2.6h-3.783l.3-2.6h-2.568v-3.571h2.981l.252-2.142h-2.545v-3.57h2.981l.344-3.024h3.782l-.343,3.024h2.453l.344-3.024h3.783l-.344,3.024H190Zm-6.741,2.142.252-2.142h-2.453l-.252,2.142Z"
													transform="translate(-174.038 -639.337)"
													fill="#e50b09"
												/>
											</svg>
										</div>
										<div class="numbers flex">
											<template v-for="(num, indx) in _.split(_.get(item, 'teaser'), ',')">
												<div class="number bold" :key="indx" v-html="num" v-if="num"></div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
					</slide-up-down>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import MapBlock from '@/components/smartComponents/MapBlock';
import fn from '../../helpers/func';
import BreadCrumb from '@/components/modules/BreadCrumb';
export default {
	props: ['contentData'],
	components: { MapBlock, BreadCrumb },
	data() {
		const _this = this;
		return {
			center: { lat: 41.716667, lng: 44.783333 },
			zoomData: 9,
			marker: '../../../assets/imgs/marker.png',
			selectedId: null,
			success: false,
			mapStyle: [
				{
					elementType: 'geometry',
					stylers: [
						{
							color: '#f5f5f5',
						},
					],
				},
				{
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'on',
						},
					],
				},
				{
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#616161',
						},
					],
				},
				{
					elementType: 'labels.text.stroke',
					stylers: [
						{
							color: '#f5f5f5',
						},
					],
				},
				{
					featureType: 'administrative.country',
					elementType: 'geometry.stroke',
					stylers: [
						{
							color: '#f54a30',
						},
						{
							weight: 2.5,
						},
					],
				},
				{
					featureType: 'administrative.land_parcel',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#bdbdbd',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'geometry',
					stylers: [
						{
							color: '#eeeeee',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#757575',
						},
					],
				},
				{
					featureType: 'poi.park',
					elementType: 'geometry',
					stylers: [
						{
							color: '#e5e5e5',
						},
					],
				},
				{
					featureType: 'poi.park',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#9e9e9e',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'geometry',
					stylers: [
						{
							color: '#ffffff',
						},
					],
				},
				{
					featureType: 'road.arterial',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#757575',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry',
					stylers: [
						{
							color: '#dadada',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#616161',
						},
					],
				},
				{
					featureType: 'road.local',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#9e9e9e',
						},
					],
				},
				{
					featureType: 'transit.line',
					elementType: 'geometry',
					stylers: [
						{
							color: '#e5e5e5',
						},
					],
				},
				{
					featureType: 'transit.station',
					elementType: 'geometry',
					stylers: [
						{
							color: '#eeeeee',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'geometry',
					stylers: [
						{
							color: '#c9c9c9',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#9e9e9e',
						},
					],
				},
			],
			dropdownList: [
				{
					title: 'ქალაქის რუკა',
				},
			],

			rules: {
				name: [
					{
						required: true,
						message: _this.$fn.tr('Please type valid Name'),
						trigger: 'blur',
					},
				],

				email: [
					{
						required: true,
						message: _this.$fn.tr('Please type email address'),
						trigger: 'blur',
					},
					{
						type: 'email',
						message: _this.$fn.tr('Please type the correct email address'),
						trigger: ['blur', 'change'],
					},
				],

				title: [
					{
						required: true,
						message: _this.$fn.tr('Please type valid title'),
						trigger: 'blur',
					},
				],
				message: [
					{
						required: true,
						message: _this.$fn.tr('Please type valid message'),
						trigger: 'blur',
					},
				],
			},
			contactData: {
				name: '',
				email: '',
				title: '',
				message: '',
			},
		};
	},
	computed: {
		socialChannels() {
			const data = this.$store.state.main.indx?.widgets?.social_channels;
			const result = {
				title: data?.title,
				list: [],
			};
			Object.values(data).forEach((obj) => {
				if (typeof obj !== 'string') result.list.push(obj);
			});

			return result;
		},
		transport() {
			const transportName = `transport_${this.$store.state.main.mallType}`;
			const data = _.get(this.$store.state.main.indx?.widgets, transportName);
			console.log(data, '123');
			const result = {
				title: data?.title,
				list: [],
			};
			Object.values(data).forEach((obj) => {
				if (typeof obj !== 'string') result.list.push(obj);
			});

			return result;
		},
		contactInfo() {
			const data = this.$store.state.main.indx.widgets;
			const mallType = this.$store.state.main.mallType || 'saburtalo';
			return {
				title: data[`book_contact_${mallType}`]?.title,
				data: [
					{
						title: _.get(data[`book_contact_${mallType}`], 'address.title'),
						content: _.get(data[`book_contact_${mallType}`], 'address.teaser'),
					},
					{
						title: _.get(data[`book_contact_${mallType}`], 'working_hours.title'),
						content: _.get(data[`book_contact_${mallType}`], 'working_hours.teaser'),
					},
					{
						title: _.get(data[`book_contact_${mallType}`], 'phone.title'),
						content: _.get(data[`book_contact_${mallType}`], 'phone.teaser'),
					},
				],
				qrCode: {
					title: 'qr',
					content: _.get(data[`book_contact_${mallType}`], 'qr[0].devices.desktop'),
				},
			};
		},
	},
	methods: {
		toggle(id) {
			if (this.selectedId == id) {
				this.selectedId = null;
			} else {
				this.selectedId = id;
			}
		},
		setMarker(val) {
			//   this.selectText = _.get(val, "title");
			//   this.currentSelect = val;
		},
		sendData() {
			this.$refs['contact']?.validate((valid) => {
				if (valid) {
					this.contactData['project'] = this.$store.state.main.mallType;
					fn.postData('main/contactform', this.contactData);

					this.success = true;

					this.contactData.name = '';
					this.contactData.email = '';
					this.contactData.title = '';
					this.contactData.message = '';

					setTimeout(() => {
						this.success = false;
					}, 5000);
				}
			});
		},
	},
	mounted() {
		// this.$refs.mapRef.$mapPromise.then(map => {
		//   map.panTo({ lat: 41.693681, lng: 44.801216 });
		// });
	},
};
</script>

<style lang="scss">
.contact-container-dropdown {
	background: #f7f7f7;
	padding: 89px 0 144px;
	padding-top: 0;
	@media (max-width: 767px) {
		.title.font-34 {
			font-size: 21px;
		}
	}
	.teaser {
		line-height: 34px;
		margin-top: 34px;
		color: #4d4d4f;
	}
	.dropdowns {
		margin-top: 89px;
		.map {
			width: 100%;
			height: 610px;
		}
		.dropdown-item {
			width: 100%;
			min-height: 60px;
			height: 100%;
			display: flex;
			justify-content: space-between;
			padding: 0 10px 10px;
			background: $white;
			flex-direction: column;
			margin-bottom: 30px;
			transition: 0.4s ease;
			&.open {
				background: #d1d1d1;
				.top {
					svg {
						transform: rotate(180deg);
					}
				}
			}
			.text a {
				color: $black;
			}
			.top {
				padding: 25px 25px 20px;

				@media (max-width: 1023px) {
					padding: 25px 25px 15px;
				}
				svg {
					transition: 0.4s ease;
				}
			}

			.content {
				background: $white;
				// padding: 50px;
				.content-container {
					padding: 10px;
					.send-message {
						padding: 60px;
						@media (max-width: 1023px) {
							padding: 20px;
							.title {
								font-size: 21px;
							}
							.teaser {
								margin-top: 21px;
							}
						}
						@media (max-width: 510px) {
							padding: 10px;
						}
						.form-container {
							display: flex;
							justify-content: space-between;
							margin-top: 30px;
							@media (max-width: 1023px) {
								flex-direction: column;
							}
							.row {
								width: 100%;
								&:first-child {
									margin-right: 30px;
								}
								.send-button {
									width: 100%;
									height: 60px;
									display: flex;
									align-items: center;
									justify-content: center;
									background: $yellow;
									color: $white;
									transition: 0.4s ease;
									&:hover {
										background: $red;
									}
								}
								.success-message {
									width: 100%;
									display: flex;
									color: #4caf50;
									margin-top: 10px;
									align-items: center;
									transition: 0.4s ease;
									justify-content: center;
								}
							}
						}
						.teaser {
							max-width: 500px;
						}
					}
					&.transport {
						padding: 30px;
					}
					.transports {
						display: grid;
						grid-template-columns: repeat(3, minmax(0px, 1fr));
						align-items: center;
						@media (max-width: 1023px) {
							grid-template-columns: repeat(1, minmax(0, 1fr));
							gap: 30px;
						}
						svg {
							margin-left: 5px;
						}
						.img {
							width: 80px;
							height: 80px;
							min-width: 80px;
							display: flex;
							align-items: center;
							justify-content: center;
							background: #f7f7f7;
							margin-right: 20px;
						}
						.title {
							margin-bottom: 5px;
						}
						.numbers {
							flex-wrap: wrap;
							.number {
								margin-right: 10px;
								color: #4d4d4f;
							}
							&:last-child {
								.number {
									@media (max-width: 1439px) {
										max-width: 250px;
									}
								}
							}
						}
					}
					&.contact {
						padding: 20px;
					}
					.contact {
						display: grid;
						grid-template-columns: repeat(5, minmax(0px, 1fr));
						align-items: center;
						@media (max-width: 1024px) {
							grid-template-columns: repeat(3, minmax(0px, 1fr));
							gap: 40px;
						}
						@media (max-width: 767px) {
							grid-template-columns: repeat(2, minmax(0px, 1fr));
						}
						@media (max-width: 510px) {
							grid-template-columns: repeat(1, minmax(0px, 1fr));
						}
						.row {
							color: #4d4d4f;
							position: relative;
							.title {
								margin-bottom: 5px;
							}
							.content {
								color: #4d4d4f;
							}
							.qr-img {
								width: 100px;
								height: 100px;
							}
							.icons {
								a {
									svg {
										width: 20px;
										path {
											fill: #4d4d4f;
										}
									}
									margin-right: 10px;

									// height: 20px;
								}
							}
							&:not(:last-child) {
								&:after {
									@media (max-width: 510px) {
										content: unset;
									}
									content: '';
									position: absolute;
									transform: translate(0, -50%);
									right: 0;
									width: 1px;
									height: 60px;
									top: 50%;
									background: rgba(77, 77, 79, 0.1);
								}
							}
							&:not(:first-child) {
								@media (max-width: 1023px) {
									padding-left: 0px;
								}
								padding-left: 50px;
							}
						}
					}
				}
				.text {
					margin: 12px 0 55px;
				}
				.contact-row {
					a {
						color: $black;
						&:first-child {
							margin-right: 55px;
						}
					}
				}
			}
		}
	}
}
</style>
